import { createContext, useContext, useState, ReactNode } from 'react'

/**
 * Overview Date Context
 * 
 * Manages date range selection for the Brand Overview (multi-retailer) dashboard.
 * Separate from FiscalWeekContext to avoid conflicts with retailer-specific pages.
 */

interface DateRange {
  start: string  // YYYY-MM-DD format
  end: string    // YYYY-MM-DD format
}

interface OverviewDateContextType {
  selectedDateRange: DateRange | null
  setSelectedDateRange: (range: DateRange | null) => void
}

const OverviewDateContext = createContext<OverviewDateContextType | undefined>(undefined)

export function OverviewDateProvider({ children }: { children: ReactNode }) {
  // Default to null - will be set to latest calendar week when data loads
  const [selectedDateRange, setSelectedDateRange] = useState<DateRange | null>(null)

  return (
    <OverviewDateContext.Provider value={{ selectedDateRange, setSelectedDateRange }}>
      {children}
    </OverviewDateContext.Provider>
  )
}

export function useOverviewDate() {
  const context = useContext(OverviewDateContext)
  if (context === undefined) {
    throw new Error('useOverviewDate must be used within an OverviewDateProvider')
  }
  return context
}

